<script setup>
  import { ref, inject, onMounted, computed } from 'vue'
  import Header from '@/components/Header.vue'
  import Footer from '@/components/Footer.vue'
  import { useRouter, RouterLink } from 'vue-router'
  import { useUserStore } from '@/stores/userStore'
  import { useDashboardStore } from '@/stores/dashboardStore'
  import HorizontalStackedBarChart from '@/components/HorizontalStackedBarChart.vue'
  import { formatDate } from '@/components/logics/dateUtil'

  const router = useRouter()
  const userStore = useUserStore()
  const dashboardStore = useDashboardStore()

  // routeのnameを取得
  const title = router.currentRoute.value.meta.title

  const breadcrumbs = [{ name: title }]

  // 日付フィルター
  const from = ref(null)
  const to = ref(null)

  // 今月の初日と最終日を取得する関数
  const getCurrentMonthRange = () => {
    const now = new Date()
    const year = now.getFullYear()
    const month = now.getMonth()

    // 月初日
    const firstDay = new Date(year, month, 1)
    // 月末日
    const lastDay = new Date(year, month + 1, 0)

    return {
      from: formatDate(firstDay, '-'),
      to: formatDate(lastDay, '-'),
    }
  }

  // ページデータ取得API呼び出し
  const getPageData = async () => {
    // 初回読み込み時は今月のデータを取得
    const currentMonth = getCurrentMonthRange()
    from.value = currentMonth.from
    to.value = currentMonth.to

    await dashboardStore.getWorkloadData(from.value, to.value)

    if (!userStore.currentUser) {
      await userStore.getCurrentUser()
    }
  }

  // フィルター変更時の処理
  const handleFilterChange = async () => {
    // 両方の値が設定されている場合のみAPI呼び出し
    if (from.value && to.value) {
      await dashboardStore.getWorkloadData(from.value, to.value)
    }
  }

  onMounted(async () => {
    await getPageData()
  })
</script>

<template>
  <Header />
  <main class="app-main">
    <div class="main-header">
      <h2>{{ title }}</h2>
      <router-link class="tab-btn" :to="{ name: 'dashboard' }">ダッシュボード</router-link>
      <div class="filters">
        <div class="period-select">
          <input type="date" v-model="from" @change="handleFilterChange" />
          <span>〜</span>
          <input type="date" v-model="to" @change="handleFilterChange" />
        </div>
      </div>
    </div>
    <div class="main-body">
      <div class="chart-area">
        <div class="chart-area-wrap">
          <HorizontalStackedBarChart :data="dashboardStore.workloadData" />
        </div>
      </div>
    </div>
  </main>
  <Footer :breadcrumbs="breadcrumbs" />
</template>

<style lang="less" scoped></style>
